import React, { useMemo } from 'react';
import {
  useElements, useStripe, CardNumberElement,
  CardCvcElement,
  CardExpiryElement
} from '@stripe/react-stripe-js';
import { Row, Col } from "react-bootstrap";
import { toastMessage } from './../../../Common/Common';
import * as code from './../../../../config/Constants';
const useOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Roboto, sans-serif",
          border: "1px solid #d2d2d2",
          padding: "5px 10px",
          "::placeholder": {
            color: "#aab7c4",
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    }),
  );

  return options;
};
const AddBillingPaymentMethod = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardNumberElement);

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      toastMessage(code.ERROR, error.message);
    } else {
      props.addNewPaymentMethod(paymentMethod.id);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={12}>
          <label>Card Number</label>
          <CardNumberElement
            options={options}
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <label>Expiration Date</label>
          <CardExpiryElement
            options={options}
          />
        </Col>

        <Col md={4}>
          <label>CVC</label>
          <CardCvcElement
            options={options}
          />
      
</Col>
</Row>
      <Row>
        <Col className="text-center">
          <button variant="primary" size="sm" className="btn-blue btn btn-primary w-140" style={{ marginTop: 20 }} onClick={(e) =>{e.preventDefault(); props.setPaymentModal()}} disabled={!stripe}>
            Cancel
    </button>
          <button variant="primary" size="sm" className="btn-blue btn btn-primary w-140" style={{ marginTop: 20, marginLeft: 20 }} type="submit" disabled={!stripe}>
            Add
    </button>
        </Col>
      </Row>
    </form >
  );
};
export default AddBillingPaymentMethod